import React from "react";
import ModalHead from "./../components/modal-head/modalHead";

import moment from "moment";
import Container from "../components/container/container";
import Content from "../components/container/content/content";

const AppInfo = (props) => {
  let appVersion = window["app-config"].applicationProperties.appVersion;
  let client = window["app-config"].runApp;
  // console.log("NAVIGATE DATA: ", props.location.state.data)
  return (
    <Container>
      <ModalHead heading="Application Info" />
      <Content>
        <div className="sl__modal--row">
          <h2>{`APP VERSION : ${appVersion}`}</h2>
        </div>
        <div className="sl__modal--row">
          <h2>{`CLIENT : ${client.toUpperCase()}`}</h2>
        </div>
        <div className="sl__modal--row">
          <h2>{`DATE TIME : ${moment(new Date()).format(
            "DD-MMM-YYYY hh:mm A"
          )}`}</h2>
        </div>
      </Content>
    </Container>
  );
};

export default AppInfo;
